import type { Context } from "../models/context";
import type { Data } from "../models/data";

export interface IGeoServiceApiKeys {
    google: string,
    here: string
}

/**
 * Setting 275 carries the keys per brand. Brands without them, or with brand data cached before
 * the keys were added, fall back to the app-wide keys until every brand is populated.
 */
export function getGeoServiceApiKeys(data: Data, context: Context): IGeoServiceApiKeys {
    const locationSettings = data.getBrandProperty("Settings")?.LOCSET;

    return {
        google: locationSettings?.googleApiKey || context.getProperty("googleMapApiKey") || "",
        here: locationSettings?.hereApiKey || context.getProperty("hereMapApiKey") || ""
    };
}
